module.exports = __webpack_public_path__ + "img/ico-check-de.faa4a582.svg";